import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class OrderAdvancePaymentProofResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'order_number': '00-1111111',
                'file': { 
                    'name': 'payment_proof', 
                    'url': 'payment_proof.pdf' 
                },
                'creation_datetime': '2025-10-12 13:00:00',
            },
            errors: []
        }
    }

    advancePaymentProof() {
        const advancePaymentProof = this.content();
        const file = advancePaymentProof.file;
        return {
            orderNumber: advancePaymentProof.order_number,
            file: { name: file.name, url: file.url },
            creationDatetime: advancePaymentProof.creation_datetime
        }
    }
}